import React from "react";
import Container from "react-bootstrap/Container";
import BreadCrumb from "../../../components/organisms/Breadcrumb/BreadCrumb";
import Headline from "../../../components/organisms/Headline/Headline";
import JobForm from "./JobForm";
import { useLocation } from "react-router-dom";

const JobEdit = () => {
  const location = useLocation();
  const jobId = location.pathname.split("/")[3];

  return <JobForm isEditMode={true} jobId={jobId} />;
};

export default JobEdit;
